// extracted by mini-css-extract-plugin
export default {"image":"MQ-z","loaded":"NQ-z","placeholder":"OQ-z"};